import { type FC } from 'react'
import styles from './loader.module.css'

export const Loader: FC = () => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <svg
        width="150"
        height="150"
        viewBox="0 0 150 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10"
      >
        <defs>
          <clipPath id="clip-e">
            <path d="M35 133.958V15.9203H108.168L114.998 35.3523H57.5619V64.9967H98.1005L104.752 84.4287H57.5619V114.436H108.348L115 133.868H35V133.958Z" />
          </clipPath>
        </defs>

        <path
          d="M35 133.958V15.9203H108.168L114.998 35.3523H57.5619V64.9967H98.1005L104.752 84.4287H57.5619V114.436H108.348L115 133.868H35V133.958Z"
          fill="black"
          fillOpacity="0.6"
        />

        <g clipPath="url(#clip-e)">
          <circle cx="75" cy="75" r="100" fill="black" className={styles.animateMoving} />
        </g>
      </svg>
    </div>
  )
}
